import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";
import Homepage from "./components/Homepage";
import axios from 'axios';

axios.defaults.baseURL = 'https://api.jobouille.fr/';
axios.defaults.headers = {'X-Requested-With': 'XMLHttpRequest'}

Vue.config.productionTip = false

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    component: Homepage
  }, {
    path: '*',
    redirect: '/'
  }]
})

new Vue({
  render: h => h(App),
  router: router,
}).$mount('#app')
